import { getAugmentedNamespace } from './_commonjsHelpers.js';
import * as index from '../node_modules/@mui/styled-engine/index.js';

var require$$1 = /*@__PURE__*/getAugmentedNamespace(index);

export { require$$1 as default };
